export const LANGUAGES = [
  "English",
  "Spanish",
  "Tagalog",
  "Korean",
  "Japanese",
];

export const TIME_ZONES = [
  { full: "Pacific", abbrev: "PST" },
  { full: "Mountain", abbrev: "MST" },
  { full: "Central", abbrev: "CST" },
  { full: "Eastern", abbrev: "EST" },
];

export const LIBRARIES = [
  "Kenya",
  "Nepal",
  "Manila",
  "Mexico",
  "Peru",
  "Belize",
];

export const WEEKDAYS = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
];

export const TIMES = ["8 AM", "10 AM", "12 PM", "2 PM", "4 PM"];

export const BOOKING_SKELETON = {
  language: "",
  timeZone: "",
  library: "",
  weekday: "",
  time: "",
};

export const BlankOption = <option style={{ display: "none" }}></option>;

export const SESSION_SKELETON = {
  id: "",
  display: "",
  endDate: "",
  notes: "",
};
